const ALT = 'Apps personalizados para Android e iOS';
const SIZES = '(max-width: 991px) 100vw, 540px';
const SRCSET =
  '/lcp/hero-480.webp 480w, /lcp/hero-600.webp 600w, /lcp/hero-800.webp 800w, /lcp/hero-1080.webp 1080w';

function hideLcpPrerender() {
  document.getElementById('lcp-prerender')?.classList.add('lcp-prerender--hide');
}

export default function HeroAppsImage({ priority = false, className, loading }) {
  const imgLoading = priority ? 'eager' : (loading ?? 'lazy');

  const handleLoad = () => {
    if (priority) hideLcpPrerender();
  };

  const setHeroRef = (node) => {
    if (priority && node?.complete) hideLcpPrerender();
  };

  return (
    <picture>
      <source type="image/webp" srcSet={SRCSET} sizes={SIZES} />
      <img
        ref={setHeroRef}
        src="/lcp/hero-600.webp"
        srcSet={SRCSET}
        sizes={SIZES}
        alt={ALT}
        width={600}
        height={450}
        className={className}
        loading={imgLoading}
        fetchPriority={priority ? 'high' : undefined}
        decoding="async"
        onLoad={priority ? handleLoad : undefined}
      />
    </picture>
  );
}
